import { FileText, type LucideIcon } from "lucide-react"

/**
 * Resolve a Lucide icon from a React element.
 *
 * Resources already pass Lucide icon elements directly
 * (e.g. <LayoutDashboard className="h-4 w-4" />).
 * We extract the component from the element's `type` prop.
 */
export function resolveIcon(iconElement: React.ReactNode): LucideIcon {
  if (!iconElement || typeof iconElement !== "object") return FileText
  const el = iconElement as React.ReactElement
  if (typeof el.type === "function" || typeof el.type === "object") {
    return el.type as LucideIcon
  }
  return FileText
}
